import { gql } from "@apollo/client";

export const SDUI_THEMES_QUERY = gql`
  query SduiThemes($isPublished: Boolean) {
    sduiThemes(isPublished: $isPublished) {
      id
      name
      label
      themeData
      heroImageUrl
      splashImageUrl
      logoOverrideUrl
      animationEffect
      floatingElementsConfig
      priority
      isPublished
      publishedAt
      createdAt
    }
  }
`;

export const SDUI_SECTIONS_QUERY = gql`
  query SduiSections($channel: String, $isPublished: Boolean) {
    sduiSections(channel: $channel, isPublished: $isPublished) {
      id
      sectionKey
      label
      sectionType
      layoutVariant
      animationEffect
      navTargetType
      navTargetId
      badgeText
      badgeColor
      config
      parentId
      sortOrder
      isPublished
      subsections {
        id
        sectionKey
        label
        sectionType
        layoutVariant
        animationEffect
        navTargetType
        navTargetId
        badgeText
        badgeColor
        config
        parentId
        sortOrder
        isPublished
      }
    }
  }
`;

export const SDUI_CONFIGS_QUERY = gql`
  query SduiConfigs($channel: String, $isPublished: Boolean) {
    sduiConfigs(channel: $channel, isPublished: $isPublished) {
      id
      key
      label
      description
      configData
      platform
      priority
      isPublished
      createdAt
    }
  }
`;

export const STOREFRONT_LAYOUT_QUERY = gql`
  query StorefrontLayout($channel: String!, $platform: String) {
    storefrontLayout(channel: $channel, platform: $platform) {
      activeTheme {
        id
        name
        label
        themeData
        heroImageUrl
        splashImageUrl
        logoOverrideUrl
        animationEffect
        floatingElementsConfig
        priority
        isPublished
      }
      sections {
        id
        sectionKey
        label
        sectionType
        layoutVariant
        animationEffect
        navTargetType
        navTargetId
        badgeText
        badgeColor
        sortOrder
        config
        subsections {
          id
          sectionKey
          label
          sectionType
          layoutVariant
          animationEffect
          navTargetType
          navTargetId
          badgeText
          badgeColor
          config
        }
      }
      configs {
        id
        key
        label
        configData
      }
    }
  }
`;

